import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import Home from './Components/Home/Home';
import About from './Components/About/About';
import AllSources from './Components/AllSources/AllSources';
import AvailableSoon from './Components/AvailableSoon/AvailableSoon';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import WarningBanner from './Components/WarningBanner/WarningBanner';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Header />
      <WarningBanner />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/allsources" element={<AllSources />} />
        <Route path="/search" element={<AvailableSoon />}>
          <Route path=":source" element={<AvailableSoon />} />
        </Route>
      </Routes>
      <Footer />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();